import Vue from 'vue'
import sendLogMixin from './send-log'

Vue.mixin({
  mixins: [sendLogMixin]
})
